var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRejectedproposal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.9 56.6",
    style: {
      enableBackground: "new 0 0 45.9 56.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#425EAB;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#DB2E27;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.5,30.9V12.1c0-0.4-0.2-0.8-0.4-1.1l-8.2-8.2c-0.3-0.3-0.7-0.5-1.1-0.5H3.5C2.7,2.3,2,3,2,3.9l0,0v48.8 c0,0.9,0.7,1.6,1.6,1.6h24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.1,2.3v8.8c0,0.9,0.7,1.6,1.6,1.6h8.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31.4,
    y1: 39.6,
    x2: 43.5,
    y2: 51.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 43.5,
    y1: 39.6,
    x2: 31.4,
    y2: 51.7
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedproposal);
export default __webpack_public_path__ + "static/media/rejected proposal.a875a348b2552f0577f0a36e4adcf7e2.svg";
export { ForwardRef as ReactComponent };